import React from 'react';

const SafariIcon = ({ width = 12, height = 12, className, id, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      role="img"
      aria-label="safari browser icon"
      {...rest}
    >
      <path
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
        fill={`url(#paint0_linear_246_6731-${id})`}
      />
      <path
        d="M10.0993 1.875L5.49219 5.49107L6.56362 6.5625L10.0993 1.875Z"
        fill="#FF0000"
      />
      <path
        d="M1.875 10.0993L5.49107 5.49219L6.5625 6.56362L1.875 10.0993Z"
        fill="white"
      />
      <path
        d="M5.99888 0.585938V1.46987M5.99888 10.4967V11.3806M6.93638 0.666295L6.7837 1.53683M5.21406 10.4243L5.06138 11.3002M7.8471 0.912723L7.54442 1.74308M4.45603 10.2234L4.15335 11.0538M5.06138 0.666295L5.21406 1.53683M6.7837 10.4243L6.93638 11.3002M4.15067 0.912723L4.45335 1.74308M7.53906 10.2234L7.84174 11.0538M3.29888 1.30915L3.74353 2.07522M8.25692 9.89129L8.69888 10.6574M2.53013 1.84487L3.09799 2.52254M8.89978 9.43861L9.46763 10.1163M1.86049 2.50915L2.53817 3.07701M9.45424 8.88415L10.1319 9.45201M1.31942 3.28594L2.08549 3.7279M9.9096 8.24129L10.6757 8.68326M0.928348 4.13772L1.75871 4.4404M10.2391 7.52344L11.0694 7.82611M0.684598 5.0404L1.55513 5.19308M10.4453 6.76808L11.3158 6.92076M0.601562 5.98326H1.48549M10.5123 5.98326H11.3962M0.68192 6.92076L1.55246 6.76808M10.4453 5.19844L11.3158 5.04576M0.931027 7.83147L1.76138 7.52879M10.2391 4.44308L11.0694 4.1404M1.32478 8.68326L2.09085 8.24129M9.9096 3.7279L10.6757 3.28594M1.86317 9.45201L2.54085 8.88415M9.45424 3.08237L10.1319 2.51451M2.52478 10.1217L3.09263 9.44397M8.89442 2.5279L9.46228 1.85022M3.29888 10.6574L3.74353 9.89129M8.25692 2.07522L8.69888 1.30915M5.52746 0.607366L5.58783 1.08951M6.42746 10.8824L6.48783 11.3645M4.60067 0.773437L4.72656 1.23951M7.27121 10.7324L7.3971 11.1984M3.71674 1.09487L3.92031 1.53147M8.0721 10.4404L8.27835 10.877M2.90246 1.56094L3.17835 1.95737M8.81942 10.0092L9.09531 10.4056M2.18192 2.16629L2.5221 2.50647M9.47567 9.46004L9.81585 9.80022M1.57924 2.88951L1.97567 3.1654M10.0275 8.80647L10.4185 9.07701M1.10781 3.70112L1.54442 3.90469M10.4533 8.05647L10.89 8.26272M0.786384 4.58504L1.25246 4.71094M10.7453 7.25558L11.2114 7.38147M0.622991 5.51451L1.10513 5.57477M10.898 6.41451L11.3801 6.47477M0.628348 6.47477L1.11049 6.41451M10.9033 5.57477L11.3855 5.51451M0.786384 7.38147L1.25246 7.25558M10.7453 4.71094L11.2114 4.58504M1.10781 8.2654L1.54442 8.06183M10.4533 3.90737L10.89 3.70379M1.57924 9.07701L1.97567 8.80111M10.0275 3.16004L10.4185 2.88951M2.90246 10.4056L3.17835 10.0092M8.81674 1.95737L9.09531 1.56094M3.71674 10.8717L3.92299 10.435M8.07478 1.52612L8.28103 1.08951M4.60067 11.1931L4.72656 10.727M7.27121 1.23415L7.3971 0.76808M5.52746 11.3565L5.58783 10.8743M6.42746 1.08147L6.48783 0.59933"
        stroke="white"
        stroke-width="0.15"
      />
      <defs>
        <linearGradient
          id={`paint0_linear_246_6731-${id}`}
          x1="0"
          y1="0"
          x2="0"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#19D7FF" />
          <stop offset="1" stopColor="#1E64F0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SafariIcon;
